<template>
  <ol class="answerList">
    <li v-if="finalAnswer.isNoAnswer" class="judgePageNoAnswer">
      ノートの答えと解答例を照らし合わせて、正解なら〇、不正解ならｘを押しましょう。
    </li>
    <li :class="{'size size--half': finalAnswer.isHalf,　'math-field': isKeyboard,
     'judgeCorrect':autoGradingPage&&isAnswerCorrectWrong, 'judgeWrong': autoGradingPage&&!isAnswerCorrectWrong}" v-else>
      <div v-if="isKeyboard && finalAnswer.label.length > 0" class="number" v-html="labelText"></div>
      <span v-else-if="finalAnswer.label" class="number">{{finalAnswer.label}}</span>
      <div v-if="finalAnswer.prefix || finalAnswer.suffix"
           :class="{'stringBox':true,'stringBox--lines':finalAnswer.isMulti,
           'stringBox--mathFieldWidth': isKeyboard && finalAnswer.label.length > 0,
           'stringBox--oneLine': isKeyboard && prefixSuffixDisplay()}">
        <div class="stringBox__string" v-if="isVertical">{{finalAnswer.prefix}}</div>
        <div class="stringBox__string" v-else-if="isKeyboard && finalAnswer.prefix.length > 0" v-html="prefixText"></div>
        <div class="stringBox__string" v-else-if="finalAnswer.prefix.length > 0">{{finalAnswer.prefix}}</div>
        <div ref="preSuffixAnswerText"
            :class="{'answerTextarea':true,
            'answerTextarea--answerMathFieldWidth': isKeyboard && finalAnswer.answer.length > 0}">
          <markdown-view :rawText="answerText(finalAnswer.answer)"></markdown-view>
        </div>
        <div class="stringBox__string" v-if="isVertical">{{finalAnswer.suffix}}</div>
        <div class="stringBox__string" v-else-if="isKeyboard && finalAnswer.suffix.length > 0" v-html="suffixText"></div>
        <div class="stringBox__string" v-else-if="finalAnswer.suffix.length > 0">{{finalAnswer.suffix}}</div>
      </div>
      <div class="answerTextarea" v-else>
        <markdown-view :rawText="answerText(finalAnswer.answer)"></markdown-view>
      </div>
    </li>
    <li v-if="!autoGradingPage" class="size size--judge">
      <div class="p-question-radio">
        <input id="radioCorrect" class="radioInput radioInput--correct" type="radio" name="S3-8-judge-btn" value="radioCorrect"
               @change="emit('grading-answer', true)" tabindex="-1">
        <div class="p-question-radio__inner" tabindex="1" @keyup.enter="keyupEnter(true)">
          <div class="label">
            <label class="label__text" for="radioCorrect"><span class="labelIcon"><span
                class="iconCorrect"></span></span></label>
          </div>
        </div>
        <input id="radioWrong" class="radioInput radioInput--wrong" type="radio" name="S3-8-judge-btn" value="radioWrong"
               @change="emit('grading-answer', false)" tabindex="-1">
        <div class="p-question-radio__inner" tabindex="2" @keyup.enter="keyupEnter(false)">
          <div class="label">
            <label class="label__text" for="radioWrong"><span class="labelIcon"><span
                class="iconWrong"></span></span></label>
          </div>
        </div>
      </div>
    </li>
  </ol>
</template>

<script setup lang="ts">
  import {ref, computed, nextTick} from "vue"
  import { markdown as md } from "@/util/markdown";

  interface IAnswerGrading{
      answer: string;
      isHalf: boolean;
      isMulti: boolean;
      prefix: string;
      suffix: string;
      label: string;
      isNoAnswer: boolean;
  }

  const preSuffixAnswerText = ref(null)
  const props = withDefaults(
    defineProps<{
      finalAnswer?: IAnswerGrading | any;
      autoGradingPage?: boolean;
      isAnswerCorrectWrong?: boolean;
      isVertical?: boolean;
      isKeyboard?: boolean;
      isScience?: boolean;
    }>(),
    {
      finalAnswer: {},
      autoGradingPage: false,
      isAnswerCorrectWrong: false,
      isVertical: false,
      isKeyboard: false,
      isScience: false,
    }
  );

  const emit = defineEmits<{
    (e: 'grading-answer', id: boolean): void,
  }>()

  const labelText = computed(() => {
    return md.render(props.finalAnswer.label);
  })

  const prefixText = computed(() => {
    return md.render(props.finalAnswer.prefix);
  })

  const suffixText = computed(() => {
    return md.render(props.finalAnswer.suffix);
  })

  function keyupEnter(value) {
    let radioCorrect: any = document.getElementById("radioCorrect")
    let radioWrong: any = document.getElementById("radioWrong")
    // for set which button is selected
    radioCorrect.checked = value
    radioWrong.checked = !value
    emit('grading-answer', value)
  }

  // NFR-3049 プレフィックスサフィックスありmathfieldではみ出す場合の表示のため
  function prefixSuffixDisplay(){
    nextTick(() => {
      let ansText:any = preSuffixAnswerText.value
      if(ansText){
        if (ansText.clientWidth <= ansText.childNodes[0].clientWidth) {
          let parent: any = ansText.parentNode
          parent.classList.remove("stringBox--oneLine")
          return false
        }
      }
    })
    return true
  }

  function answerText(text:string) {
    // NFR-3670 理科で下付き、上付き文字がある場合\ceコマンドを付けて表示する
    if(props.isScience && text.length > 0){
      let isSubSup =(/\_|\^/g).test(text)
      // add chemical equeation \\ce{fourmula} for rendering sub and superscript
      if(isSubSup){
        text = text.replace(/(\$)(.*?)(\$)/g, '$\\ce{$2}$')
      }
    }
    return text
  }
</script>
